export interface ColumnSettings {
    key: string;
    visible: boolean;
    order: number;
}

export interface SafetySettingsState {
    breachColumnSettings: ColumnSettings[];
    hideSilentEquipment: boolean;
}

export const safetySettingsInitialState: SafetySettingsState = {
    breachColumnSettings: [
        { key: 'date', visible: true, order: 0 },
        { key: 'equipment', visible: true, order: 1 },
        { key: 'operator', visible: true, order: 2 },
        { key: 'department', visible: true, order: 3 },
        { key: 'shock', visible: true, order: 4 },
        { key: 'severity', visible: true, order: 5 },
        { key: 'speedChange', visible: true, order: 6 },
        { key: 'review', visible: true, order: 7 },
        { key: 'actions', visible: true, order: 8 },
    ],
    hideSilentEquipment: true,
};